var _g;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCodeSmallFilled(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "46 / Fill / Code - No Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53492 4.222C1.82024 3.647 2.40581 3.2081 3.05822 3.08033C3.14793 3.06274 6.26745 3.04663 9.99048 3.04455C16.5366 3.04088 16.9926 3.02986 17.3621 3.20314C17.4126 3.22682 17.4615 3.25394 17.5241 3.28499C18.0524 3.54699 18.5281 4.16683 18.6519 4.75442C18.6829 4.90186 18.6964 6.46934 18.696 9.88303C18.6954 14.5683 18.7045 15.0225 18.5299 15.3895C18.5018 15.4486 18.4689 15.5054 18.4305 15.5773C18.1862 16.0342 17.7546 16.4044 17.2474 16.5924L17.0043 16.6825L10.1128 16.6931C5.38054 16.7004 3.15592 16.6904 3.01255 16.6613C2.28254 16.5129 1.62495 15.9195 1.39509 15.2017L1.30476 14.9195V9.89108C1.30476 5.15623 1.29649 4.73602 1.45216 4.38944C1.47577 4.33687 1.50316 4.28599 1.53492 4.222ZM11.3916 5.6776L9.93143 5.38437L8.57383 14.059L10.034 14.3523L11.3916 5.6776ZM16.8892 9.83617L13.6007 6.53435L12.5488 7.59056L14.7853 9.83617L12.5488 12.0818L13.6007 13.138L16.8892 9.83617ZM7.44775 7.59056L6.39581 6.53435L3.10735 9.83617L6.39581 13.138L7.44775 12.0818L5.21121 9.83617L7.44775 7.59056Z",
    fill: "var(--secondary-4)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSmallFilled);
export default __webpack_public_path__ + "static/media/codeSmallFilled.9ae1d5ea44a84e757b67302d9d06a794.svg";
export { ForwardRef as ReactComponent };